import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';

const Tab1 = ({ formdata,setformdata,handlechange }) => {
  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>
      <div className="col-6 ">
        <div className="mb-3">
          <Input
            name="hsncode"
            label="HSN Code"
            style={{ height: "30px" }}
            value={formdata.hsncode}
            onChange={handlechange}
          />
        </div>
      </div>
      <div className="col-6">
        <div className="mb-3">
          <Textarea
            style={{
              height: "38px",
              border: "",
            }}
            name='description'
            label="Description"
            value={formdata.description}
            onChange={handlechange}
          />
        </div>
      </div>
    </div>
  )
}

export default Tab1